export default __webpack_public_path__ + "static/media/28e9611c8232f9e4ec4fb0fe06a5e35e.87394d23.png";